import ComponentLayout from "../../../../src/layouts/component-layout";
import { LabelColors, CardIconColors } from '@primer/react-brand';
import { IconColors } from '@primer/react-brand';
import { PropTableValues } from "../../../../src/components";
import { CopilotIcon, RocketIcon, GitBranchIcon } from '@primer/octicons-react';
import * as React from 'react';
export default {
  ComponentLayout,
  LabelColors,
  CardIconColors,
  IconColors,
  PropTableValues,
  CopilotIcon,
  RocketIcon,
  GitBranchIcon,
  React
};